'use strict';

var $blogMobileMenu = false,
    $blogCategoryPage = false,
    $primaryContent = false,
    blogMobileMenuOffset = 0;

window.addEventListener('mainJsLoaded', function (event) {
    blogInit();
});

function toggleblogMenuSticky() {
    if (!$blogMobileMenu.hasClass('sticky')) {
        blogMobileMenuOffset = $blogMobileMenu.offset().top;
    }

    if (window.vbqUtils.breakpoint.is('mobileAndTablet')) {
        if (window.vbqUtils.cache.$window.scrollTop() > blogMobileMenuOffset) {
            $blogMobileMenu.addClass('sticky');
            $primaryContent.css('paddingTop', $blogMobileMenu.outerHeight() + 'px');
        } else {
            $blogMobileMenu.removeClass('sticky');
            $primaryContent.css('paddingTop', '0');
        }
    } else {
        if ($blogMobileMenu.hasClass('sticky')) {
            $blogMobileMenu.removeClass('sticky');
            $primaryContent.css('paddingTop', '0');
        }
    }
}

function blogInit() {
    var $blogCategoryWrapper = $('.js-blog-category-carousel'), // home blog page
        $otherArticleWrapper = $('.js-blogotherarticles-section'), // blog article page
        $sliderArticleLayout = $('.js-article-slider-layout');

    if (window.vbqUtils.isSR) {
        var sliderArticleArrowsID = $sliderArticleLayout.parents('.js-article-slider-wrapper').find('.js-article-slider-arrows').attr('id');
    }

    $blogMobileMenu = $('.js-blog-mobile-menu');
    $blogCategoryPage = $('.blog-category-page');
    $primaryContent = $('.primary-content');

    // ERB-160 - Blog articles structure
    // Functions for the load more buttons
    // Blog HP: Category sections & Other Articles on Blog Article Page
    $('.js-blog-home-more').on('click', function (e) {
        e.preventDefault();
        var $this = $(this),
            $ul = $this.siblings('ul'),
            url = $this.data('href') + '&start=' + $ul.find('li').not('.slick-cloned, .slick-dots li').length;

        // EADA21-86 - ADA - #165 & #194 - Blog article view more button does not move the user's focus to the targeted location on the page.
        window.vbqUtils.progress.show($this);
        $ul.find('.js-blog-article-focus').removeClass('js-blog-article-focus').removeAttr('tabindex');

        $.ajax({
            url: url
        })
        .done(function (data) {
            var $data = $(data).filter('.js-category-blog-article'),
                currentArticleAmount = parseInt($ul.attr('data-article-amount'), 10) || 0;

            if ($ul.hasClass('slick-initialized')) {
                $ul.slick('unslick');
            }
            // plain data returned by Ajax breaks slider, we need only new articles and .no-showmore input
            $ul.append($data).find('img').addClass('lazypreload'); //fix for padding between slide content and dots

            // SR-47 - SFCC - blog home and section pages
            if (window.vbqUtils.isSR) {
                if (window.vbqUtils.breakpoint.is('mobile')) {
                    $ul.slick({
                        slidesToShow: 1,
                        dots: true,
                        arrows: false,
                        variableWidth: true,
                        infinite: true,
                        // EADA22-15 ADA - #165 On blog article view more button, set focus onto the next newly loaded article link.
                        initialSlide: $data.length ? currentArticleAmount : 0
                    });

                    // EADA22-15 ADA - #165 On blog article view more button, set focus onto the next newly loaded article link.
                    if ($data.length) {
                        $ul.find('.slick-slide.slick-active .js-blog-tile-title').focus();
                    }
                }
                else {
                    $ul.find('.js-blog-article-focus').focus();
                }
            }
            else {
                if (window.vbqUtils.breakpoint.is('mobileAndTablet')) {
                    $ul.slick({
                        slidesToShow: 1,
                        dots: true,
                        arrows: false,
                        // EADA22-15 ADA - #165 On blog article view more button, set focus onto the next newly loaded article link.
                        initialSlide: $data.length ? currentArticleAmount : 0
                    });
    
                    // EADA22-15 ADA - #165 On blog article view more button, set focus onto the next newly loaded article link.
                    if ($data.length) {
                        $ul.find('.slick-slide.slick-active .js-blog-tile-title').focus();
                    }
                }
                else {
                    $ul.find('.js-blog-article-focus').focus();
                }
            }

            // EADA22-15 ADA - #165 On blog article view more button, set focus onto the next newly loaded article link.
            // actualize blog article amount
            $ul.attr('data-article-amount', currentArticleAmount + $data.length);

            $ul.append($(data).filter('input'));

            if ($ul.find('.no-showmore').length) {
                $this.remove();
                $('.no-showmore').remove();
            }
        })
        .always(function () {
            window.vbqUtils.progress.hide();
        });
    });

    $('.js-blog-category-more').on('click', function (e) {
        e.preventDefault();
        var $this = $(this),
            $ul = $this.siblings('ul'),
            url = $this.data('href') + '&start=' + $ul.find('.blog-category-article').length;

        window.vbqUtils.progress.show($this);

        $.ajax({
            url: url
        }).done(function (data) {
            $ul.append(data);
            if ($ul.find('.no-showmore').length) {
                $this.remove();
                $('.no-showmore').remove();
            }
        })
        .always(function () {
            window.vbqUtils.progress.hide();
        });
    });

    // home blog page
    $blogCategoryWrapper.on('init', function (ev, slick, direction) {
        $(this).find('img').addClass('lazypreload'); //fix for padding between slide content and dots
    });

    // blog article page
    $otherArticleWrapper.on('init', function (ev, slick, direction) {
        $(this).find('img').addClass('lazypreload'); //fix for padding between slide content and dots
    });

    window.vbqUtils.breakpoint.set([
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('mobile'),
            enter: function () {
                // home blog page
                if (window.vbqUtils.isSR) {
                    $blogCategoryWrapper.slick({
                        slidesToShow: 1,
                        dots: true,
                        arrows: false,
                        variableWidth: true,
                        infinite: true
                    });

                    // blog article page
                    $otherArticleWrapper.slick({
                        slidesToShow: 1,
                        dots: true,
                        arrows: false,
                        variableWidth: true
                    });
                }
            }
        },
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('tablet'),
            enter: function () {
                // home blog page
                if (window.vbqUtils.isSR) {
                    if ($blogCategoryWrapper.hasClass('slick-initialized')) {
                        $blogCategoryWrapper.slick('unslick');
                    }

                    // blog article page
                    if ($otherArticleWrapper.hasClass('slick-initialized')) {
                        $otherArticleWrapper.slick('unslick');
                    }
                }
            }
        },
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('mobileAndTablet'),
            enter: function () {
                // home blog page
                if (!window.vbqUtils.isSR) {
                    $blogCategoryWrapper.slick({
                        slidesToShow: 1,
                        dots: true,
                        arrows: false
                    });

                    if ($blogCategoryPage.length) {
                        window.vbqUtils.cache.$window.scroll(window.vbqUtils._debounce(toggleblogMenuSticky, 50));
                    }

                    $otherArticleWrapper.slick({
                        slidesToShow: 1,
                        dots: true,
                        arrows: false
                    });
                }

                if ($blogMobileMenu.length && !$blogMobileMenu.hasClass('accordion-initialized')) {
                    $blogMobileMenu.customAccordion();
                }

                $blogMobileMenu.find('.js-blog-mobile-toggle').on('click', function () {
                    $blogCategoryPage.toggleClass('blog-menu-active');
                });
            }
        },
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('fromDesktop'),
            enter: function () {
                // home blog page
                if ($blogCategoryWrapper.hasClass('slick-initialized')) {
                    $blogCategoryWrapper.slick('unslick');
                }

                // blog article page
                if ($otherArticleWrapper.hasClass('slick-initialized')) {
                    $otherArticleWrapper.slick('unslick');
                }

                if ($blogMobileMenu.length && $blogMobileMenu.hasClass('accordion-initialized')) {
                    $blogMobileMenu.customAccordion('destroy');
                }

                $blogCategoryPage.removeClass('blog-menu-active');
            }
        }
    ]);

    // case: asset with subArticleLayout == 'sliderLayout' : slidersubarticle.isml
    $sliderArticleLayout.find('img').first().one('load', function () {
        if (window.vbqUtils.breakpoint.is('fromDesktop')) {
            if (window.vbqUtils.isSR) {
                $sliderArticleLayout.slick({
                    slidesToShow: 1,
                    dots: false,
                    arrows: true,
                    appendArrows: '#' + sliderArticleArrowsID
                });
            }
            else {
                $sliderArticleLayout.slick({
                    slidesToShow: 1,
                    dots: false,
                    arrows: true
                });
            }
        }
        else {
            $sliderArticleLayout.slick({
                slidesToShow: 1,
                dots: true,
                arrows: false
            });
        }
    });

    // carousel re-init on media query change only!
    window.vbqUtils.breakpoint.set([
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('mobileAndTablet'),
            enter: function () {
                $sliderArticleLayout.slick('unslick').slick({
                    slidesToShow: 1,
                    dots: true,
                    arrows: false
                });
            }
        },
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('fromDesktop'),
            enter: function () {
                if (window.vbqUtils.isSR) {
                    $sliderArticleLayout.slick('unslick').slick({
                        slidesToShow: 1,
                        dots: false,
                        arrows: true,
                        appendArrows: '#' + sliderArticleArrowsID
                    });
                }
                else {
                    $sliderArticleLayout.slick('unslick').slick({
                        slidesToShow: 1,
                        dots: false,
                        arrows: true
                    });
                }
            }
        }
    ], true); // on media query change only

    // case: asset with subArticleLayout == 'videoAndSlider' : videoandslideshowsubarticle.isml
    var $blogCarousel = $('.js-blog-carousel');

    if (window.vbqUtils.isSR) {
        var blogCarouselArrowsID = $blogCarousel.parents('.js-blog-carousel-wrapper').find('.js-blog-carousel-arrows').attr('id');
    }

    $blogCarousel.find('img').first().one('load', function () {
        if (window.vbqUtils.breakpoint.is('fromDesktop')) {
            if (window.vbqUtils.isSR) {
                $blogCarousel.slick({
                    slidesToShow: 1,
                    dots: false,
                    arrows: true,
                    swipe: true,
                    adaptiveHeight: true,
                    appendArrows: '#' + blogCarouselArrowsID
                });
            }
            else {
                $blogCarousel.slick({
                    slidesToShow: 1,
                    dots: false,
                    arrows: true,
                    swipe: true,
                    adaptiveHeight: true
                });
            }
        }
        else {
            $blogCarousel.slick({
                slidesToShow: 1,
                dots: true,
                arrows: false,
                swipe: true,
                adaptiveHeight: true
            });
        }
    });

    // carousel re-init on media query change only!
    window.vbqUtils.breakpoint.set([
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('mobileAndTablet'),
            enter: function () {
                $blogCarousel.slick('unslick').slick({
                    slidesToShow: 1,
                    dots: true,
                    arrows: false,
                    swipe: true,
                    adaptiveHeight: true
                });
            }
        },
        {
            media: window.vbqUtils.breakpoint.getMediaQuery('fromDesktop'),
            enter: function () {
                if (window.vbqUtils.isSR) {
                    $blogCarousel.slick('unslick').slick({
                        slidesToShow: 1,
                        dots: false,
                        arrows: true,
                        swipe: true,
                        adaptiveHeight: true,
                        appendArrows: '#' + blogCarouselArrowsID
                    });
                }
                else {
                    $blogCarousel.slick('unslick').slick({
                        slidesToShow: 1,
                        dots: false,
                        arrows: true,
                        swipe: true,
                        adaptiveHeight: true
                    });
                }
            }
        }
    ], true); // on media query change only

    // ENF-66 - Blog magazine - add Product set feature
    // case: product carousel - asset with subArticleLayout == 'productSetCarousel' : productsetcarouselsubarticle.isml
    // note: 2 rows on mobile
    var $productSetsCarousel = $('.js-productsets-carousel');

    if (window.vbqUtils.isSR) {
        var productSetsCarouselID = $productSetsCarousel.parents('.js-productsets-carousel-wrapper').find('.js-productsets-carousel-arrows').attr('id');
    }

    var setLooksCarousel = function () {
        if ($productSetsCarousel.length) {
            if ($productSetsCarousel.hasClass('slick-initialized')) {
                $productSetsCarousel.slick('unslick');
            }

            var isMobile = window.vbqUtils.breakpoint.is('mobile'),
                isTablet = window.vbqUtils.breakpoint.is('tablet'),
                productSetsCarouselConfig = {
                    slidesToShow: isMobile ? 2 : (isTablet ? 3 : 4),
                    slidesToScroll: isMobile ? 2 : (isTablet ? 3 : 4),
                    rows: isMobile ? 2 : 1,
                    dots: isMobile || isTablet,
                    arrows: !isMobile && !isTablet,
                    swipe: true,
                    mobileFirst: true,
                    adaptiveHeight: true
                };

            if (window.vbqUtils.isSR) {
                productSetsCarouselConfig.appendArrows = '#' + productSetsCarouselID;
            }

            $productSetsCarousel.slick(productSetsCarouselConfig);
        }
    };

    window.vbqUtils.cache.$window.resize(window.vbqUtils._debounce(function () {
        setLooksCarousel();
    }, 200));

    setLooksCarousel();

    // ECM-1006 - Blog article - Carousel layout issue
    // case : product carousel - asset with subArticleLayout == 'productsHighlight'
    var $blogProductCarousel = $('.js-blogProductCarousel');

    var setBlogCarousel = function () {
        if ($blogProductCarousel.length) {
            if ($blogProductCarousel.hasClass('slick-initialized')) {
                $blogProductCarousel.slick('unslick');
            }

            var isDesktop = window.vbqUtils.breakpoint.is('fromDesktop'),
                isMobile = window.vbqUtils.breakpoint.is('mobile'),
                isTablet = window.vbqUtils.breakpoint.is('tablet'),
                tiles = $blogProductCarousel.children().length;

            // for desktop view don't create carousel if the number of tiles is less then 5
            // for tablet view don't create carousel if the number of tiles is less then 4
            // for mobile view don't create carousel if the number of tiles is less then 3
            if ((tiles < 5 && isDesktop) ||
                (tiles < 4 && isTablet) ||
                (tiles < 3 && isMobile))
            {
                return;
            }

            $blogProductCarousel.slick({
                slidesToShow: isMobile ? 2 : (isTablet ? 3 : 4),
                slidesToScroll: isMobile ? 2 : (isTablet ? 3 : 4),
                dots: isMobile || isTablet,
                arrows: !isMobile && !isTablet,
                swipe: true,
                mobileFirst: true,
                adaptiveHeight: true
            });
        }
    };

    window.vbqUtils.cache.$window.resize(window.vbqUtils._debounce(function () {
        setBlogCarousel();
    }, 200));

    setBlogCarousel();
}
